// Functionality for Header search button and popup
// Provided as a separate file to allow for static rendering.

import { ElementAttributes } from '@ratehub/base-ui';
import closeSearchPopup from '../src/functions/closeSearchPopup';


function initializeSearch() {
    const searchButton = document.querySelector(`#${ElementAttributes.HEADER_SEARCH_BUTTON_ID}`);

    if (searchButton) {
        searchButton.addEventListener('click', handleSearchButtonClick);
    }

    const closeButton = document.querySelector('.search-wrapper .closeButton');

    if (closeButton) {
        closeButton.addEventListener('click', closeSearchPopup);
    }

    const searchPopup = document.querySelector(`#${ElementAttributes.HEADER_SEARCH_POPUP_ID}`);

    if (searchPopup && searchButton) {
        document.addEventListener('click', (event) => {
            // Check if the click is outside the popup and outside the header search button
            if (!searchPopup.contains(event.target) && !searchButton.contains(event.target)) {
                closeSearchPopup();
            }
        });

        // prevent the popup from hiding when clicking inside it
        searchPopup.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    }
}

function handleSearchButtonClick() {
    const searchPopup = document.querySelector(`#${ElementAttributes.HEADER_SEARCH_POPUP_ID}`);
    searchPopup.classList.toggle('isOpen');
}

export default initializeSearch;
